export function formatCpfCnpj(value: string | null) {
    if (value == null) return '';

    // remove tudo que não for dígito
    const digits = String(value).replace(/\D/g, '');

    if (digits.length <= 11) {
        // mascara CPF (parcial ou completo): 000.000.000-00
        return digits
            .replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2}).*/, (m, g1, g2, g3, g4) => {
                let out = g1 || '';
                if (g2) out += '.' + g2;
                if (g3) out += '.' + g3;
                if (g4) out += '-' + g4;
                return out;
            });
    } else {
        // mascara CNPJ (parcial ou completo): 00.000.000/0000-00
        return digits
            .replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2}).*/, (m, g1, g2, g3, g4, g5) => {
                let out = g1 || '';
                if (g2) out += '.' + g2;
                if (g3) out += '.' + g3;
                if (g4) out += '/' + g4;
                if (g5) out += '-' + g5;
                return out;
            });
    }
}

export function maskCpf(cpf: string): string {
    if (!cpf) return '';

    // Remove tudo que não for número
    const cleanedCpf = cpf.replace(/\D/g, '');

    // Garante que tenha 11 dígitos
    if (cleanedCpf.length !== 11) return cpf;

    // Aplica a máscara
    return `***.${cleanedCpf.substring(3, 6)}.${cleanedCpf.substring(6, 9)}-**`;
}
